import React from "react";

import {
  TrackingPipelineEvents,
  AnalyticsEvents,
} from "~/sdks/LocalContent/types";

import { useTracking } from "@local-logic/core/tracking";
import { useTranslation } from "react-i18next";

import type { ScoreKey } from "~/sdks/LocalContent/types";

import { ScoreIcon } from "~/components/ScoreIcon";
import { ItemButton } from "~/sdks/LocalContent/components/ItemButton";

import { useRootElement } from "../context";

export function Score({
  scoreKey,
  backgroundColor,
  fillColor,
}: {
  scoreKey: ScoreKey;
  backgroundColor?: string;
  fillColor?: string;
}) {
  const { t } = useTranslation(["common"]);
  const tracking = useTracking();
  const { isExpanded, activeScore, onSelectScore } = useRootElement();

  const handleOnSelectScore = (score: ScoreKey) => () => {
    if (typeof onSelectScore === "undefined") {
      return;
    }

    onSelectScore(score)();

    const eventAttributes = {
      scoreKey: score,
      isSidebarExpanded: isExpanded,
    };

    tracking.postEvent({
      eventType: TrackingPipelineEvents.SIDEBAR_SCORE_SELECTED,
      eventAttributes: Object.entries(eventAttributes).map(([key, value]) => ({
        label: key,
        data: value,
      })),
    });

    tracking.trackAnalyticsEvent({
      eventName: AnalyticsEvents.SIDEBAR_SCORE_SELECTED,
      eventAttributes,
    });
  };

  return (
    <ItemButton
      text={t(`common:scores.${scoreKey}.title`)}
      isDisabled={!isExpanded}
      isCollapsed={!isExpanded}
      isActive={activeScore === scoreKey}
      icon={{
        element: <ScoreIcon score={scoreKey} />,
        backgroundColor,
        fillColor,
      }}
      onClick={handleOnSelectScore(scoreKey)}
      data-testid="sidebar-score-item"
      data-score={scoreKey}
    />
  );
}
